export default __webpack_public_path__ + "static/media/scroll_brand_logo.ea3b717f.svg";